import ChangePassword from './ChangePasswordContainer'

export default ChangePassword
